import "./style.scss";

const Footer = ({childElem=null}) => {
  return <div className="footer">
    {childElem != null && childElem}
  </div>
}

export default Footer;